<script setup lang="ts">
  import { computed } from 'vue'
  import { BasePopup } from '@qic/ui-components'
  import QuotePopupContent from '../QuotePopupContent'
  import { useI18n } from 'vue-i18n'

  interface Props {
    active?: boolean
    description?: string
  }

  interface Emits {
    (e: 'update:active', value: false): void
  }

  const props = withDefaults(defineProps<Props>(), {
    active: false,
    description: '',
  })

  defineEmits<Emits>()

  const { t } = useI18n()

  const paymentText = computed(() => {
    if (props.description) return props.description
    return null
  })
</script>

<template>
  <BasePopup v-if="active" big @close="$emit('update:active', false)">
    <QuotePopupContent>
      <template #header>{{ t('payment_terms_popup.heading') }}</template>
      {{ paymentText }}
    </QuotePopupContent>
  </BasePopup>
</template>
